// extracted by mini-css-extract-plugin
module.exports = {"problem":"problem_problem__KaqQf"};